import { render, staticRenderFns } from "./AllowanceStats.vue?vue&type=template&id=b2120518&scoped=true"
import script from "./AllowanceStats.vue?vue&type=script&lang=js"
export * from "./AllowanceStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2120518",
  null
  
)

export default component.exports